(() => {
  document.addEventListener('click', event => {
    const choice = event.target.closest('[data-rexi-combo-choice]');
    if (!choice) return;
    const offer = choice.closest('.rexi-combo-offer');
    if (!offer) return;
    const key = choice.dataset.rexiComboChoice;
    offer.querySelectorAll('[data-rexi-combo-choice]').forEach(button => {
      const selected = button === choice;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-selected', String(selected));
    });
    offer.querySelectorAll('[data-rexi-combo-panel]').forEach(panel => {
      const selected = panel.dataset.rexiComboPanel === key;
      panel.classList.toggle('is-active', selected);
      panel.hidden = !selected;
    });
  });

  /* A cart refresh can retain an old scroll position. Reveal both offer cards
     from their beginning whenever the drawer is opened. */
  const drawer = document.querySelector('sht-cart-drwr');
  if (drawer) {
    new MutationObserver(() => {
      if (!drawer.hasAttribute('open')) return;
      requestAnimationFrame(() => {
        const body = drawer.querySelector('.drawer__body');
        if (body) body.scrollTop = 0;
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }
})();
